import styled from 'styled-components';
import { ContentContainer, Heading } from '@snsw-gel/react';

export const StyledHeadingContainer = styled(ContentContainer).attrs({ className: '' })`
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  background-color: #f4f7f9;
`;

export const StyledServiceTitle = styled.p`
  margin: 0 0 3rem 0;
  font-size: 0.875rem;
`;

export const StyledHeading = styled(Heading)`
  margin-top: 0;
  margin-bottom: 1rem;
`;

export const StyledContentContainer = styled(ContentContainer).attrs({ className: '' })`
  padding-top: 0;
`;
